import { getApi, postApi, fetchApi } from './utils';

export const appLaunch = () => postApi(`api/v2/app_launch`);
export const apiFetchSiteInfo = () => getApi('api/v3/web/guest/site_info');
export const logout = () => postApi('api/v2/logout');

export const fetchCampaign = name => getApi(`api/v3/campaigns/${name}`);
export const fetchQuizzesHistory = ({ userId, conceptId }) =>
  getApi(
    `api/v2/students/${userId}/quizzes/stat/history?concept_id=${conceptId}`
  );
export const fetchNextQuiz = ({ userId, conceptId }) =>
  getApi(`api/v2/students/${userId}/quizzes?concept_id=${conceptId}`);
export const postQuizAnswer = ({ userId, quizId, data }) =>
  postApi(`api/v2/students/${userId}/quizzes/${quizId}/answers`, { data });
export const fetchQuiz = quizId => getApi(`api/v2/quizzes/${quizId}`);
export const fetchSchoolSubjects = () => getApi('api/v3/schools/subjects');
export const fetchAccomplishments = subjectId =>
  getApi(`api/v3/schools/subjects/${subjectId}/accomplishments`);
export const fetchAccomplishmentsGraph = subjectId =>
  getApi(`api/v3/schools/subjects/${subjectId}/accomplishments/graph`);
export const fetchAccomplishmentsForTeacher = (subjectId, studentId) =>
  getApi(`api/v3/schools/analysis/subjects/${subjectId}/accomplishments`, {
    params: {
      student_id: studentId,
    },
  });
export const fetchAccomplishmentsGraphForTeacher = (subjectId, studentId) =>
  getApi(
    `api/v3/schools/analysis/subjects/${subjectId}/accomplishments/graph`,
    {
      params: {
        student_id: studentId,
      },
    }
  );

export const patchConceptChecked = ({ subtopicId, conceptId, isChecked }) =>
  fetchApi(
    `api/v3/students/subtopics/${subtopicId}/concept_checked_lists`,
    'patch',
    {
      data: {
        concept_id: conceptId,
        is_checked: isChecked,
      },
    }
  );

export const fetchSchoolScoreRecords = ({
  subjectId,
  assessmentType,
  year,
}) => {
  const yearParm = year ? `&year=${year}` : '';

  return getApi(
    `api/v3/schools/subjects/${subjectId}/scores?assessment_type=${assessmentType}${yearParm}`
  );
};

export const fetchSchoolScoreRecordsByTutor = ({
  subjectId,
  assessmentType,
  year,
  studentId,
}) => {
  const yearParm = year ? `&year=${year}` : '';

  return getApi(
    `api/v3/schools/analysis/subjects/${subjectId}/scores?assessment_type=${assessmentType}${yearParm}&student_id=${studentId}`
  );
};

export const fetchRecordDetail = ({ subjectId, recordId }) =>
  getApi(`api/v3/schools/subjects/${subjectId}/scores/${recordId}`);

export const fetchRecordDetailByTutor = ({ subjectId, recordId, studentId }) =>
  getApi(
    `api/v3/schools/analysis/subjects/${subjectId}/scores/${recordId}?student_id=${studentId}`
  );

export const fetchScoreTypes = subjectId =>
  getApi(`api/v3/schools/subjects/${subjectId}/score_types`);

export const fetchScoreTypesByTutor = ({ subjectId, studentId }) =>
  getApi(
    `api/v3/schools/analysis/subjects/${subjectId}/score_types?student_id=${studentId}`
  );
export const fetchRecoreDetailGraph = ({ subjectId, recordId }) =>
  getApi(`api/v3/schools/subjects/${subjectId}/scores/${recordId}/graph`);

export const fetchRecoreDetailGraphByTutor = ({
  subjectId,
  recordId,
  studentId,
}) =>
  getApi(
    `api/v3/schools/analysis/subjects/${subjectId}/scores/${recordId}/graph?student_id=${studentId}`
  );

export const fetchDropDownData = () =>
  getApi('api/v3/schools/analysis/query_params');
export const fetchAssessmentList = ({ semesterId, classId, subjectId }) =>
  getApi(
    `api/v3/schools/analysis/assessments?semester_id=${semesterId}&school_class_id=${classId}&subject_id=${subjectId}`
  );
export const fetchAssessmentDetail = assessmentId =>
  getApi(`api/v3/schools/analysis/${assessmentId}/assessment_detail`);
export const fetchMasteryList = ({ semesterId, classId, subjectId }) =>
  getApi(
    `api/v3/schools/analysis/mastery_list?semester_id=${semesterId}&school_class_id=${classId}&subject_id=${subjectId}`
  );
export const fetchMasteryDetail = ({ semesterId, classId, subtopicId }) =>
  getApi(
    `api/v3/schools/analysis/mastery_detail?semester_id=${semesterId}&school_class_id=${classId}&subtopic_id=${subtopicId}`
  );
export const fetchStudentList = ({ semesterId, classId }) =>
  getApi(
    `api/v3/schools/students_list?semester_id=${semesterId}&school_class_id=${classId}`
  );
export const getPracticeSubjects = () =>
  getApi('api/v3/schools/pilot/subjects_entry');

export const getPracticeConcepts = id =>
  getApi(`api/v3/schools/pilot/concept_distribution?subject_id=${id}`);

export const getConceptDetail = id =>
  getApi(`api/v3/schools/pilot/concepts/${id}`);

export const getConceptQuizzies = id =>
  getApi(`api/v3/schools/pilot/concepts/${id}/quizzes`);

export const postPracticeQuizziesResult = data =>
  postApi('api/v3/schools/pilot/quizzes', {
    data,
  });



// WEBPACK FOOTER //
// ./app/services/apis.js